import { useSelector } from 'react-redux';

// Three-phase reports model per Stevan's spec (2026-06-02):
//   phase1 = trial: sees one sample report (first played match of current season)
//   phase2 = active app sub, no Reports add-on: same sample affordance, click → upsell
//   phase3 = active app sub + Reports add-on: full access, all seasons, per-match
//   locked = cancelled / expired (SubscriptionGate handles)
export const REPORTS_PHASE = {
  PHASE1: 'phase1',
  PHASE2: 'phase2',
  PHASE3: 'phase3',
  LOCKED: 'locked',
};

export const deriveReportsPhase = (subscription) => {
  if (!subscription) return REPORTS_PHASE.LOCKED;
  const { status, reports_addon: addon } = subscription;
  if (status === 'trial') return REPORTS_PHASE.PHASE1;
  if (status === 'active') {
    return addon?.is_active ? REPORTS_PHASE.PHASE3 : REPORTS_PHASE.PHASE2;
  }
  return REPORTS_PHASE.LOCKED;
};

export const useReportsPhase = () =>
  useSelector((state) => deriveReportsPhase(state.user?.subscription));

// matches_list from fetchPlayerOverview is already season-scoped. Pick the
// first chronological match where the player logged ≥1 minute.
export const findFirstPlayedMatch = (matches) => {
  if (!Array.isArray(matches)) return null;
  const played = matches.filter((m) => Number(m.mins_played) > 0 && m.date);
  played.sort((a, b) => new Date(a.date) - new Date(b.date));
  return played[0] ?? null;
};

// Given a list of `available_seasons` (newest-first per backend) and the
// current season id, return the season id immediately preceding it.
export const previousSeasonId = (availableSeasons, currentSeasonId) => {
  if (!Array.isArray(availableSeasons) || !currentSeasonId) return null;
  const idx = availableSeasons.findIndex((s) => Number(s.id) === Number(currentSeasonId));
  if (idx < 0) return null;
  const next = availableSeasons[idx + 1];
  return next ? Number(next.id) : null;
};
